// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import clickOutside from "v-click-out";
// import "element-ui/lib/theme-chalk/index.css";
import "../theme/index.css";
import ElementUI from 'element-ui';
import App from "./App";
import router from "./router";
import "./permission";
import store from "@/store";
import jsCookie from "js-cookie";
import Vuex from "vuex";
import "@/styles/globals.scss";
import VueClipBoard from 'vue-clipboard2'
// 全局导出组件
import exportFileBtn from '@/components/exportFileBtn/exportFileBtn.vue';
import './directives'; // 全局挂载自定义指令
import './assets/iconFont/iconfont.css'; // 全局引入iconfont
import viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

Vue.use(viewer,{
  defaultOptions: {
    zIndex: 9999,
    navbar:false,
    toolbar:false,
    title:false,
  }
})

Vue.use(clickOutside);
Vue.use(ElementUI);
Vue.use(router);
Vue.use(Vuex);
Vue.use(VueClipBoard)
Vue.config.productionTip = false;
Vue.prototype.$cookie = jsCookie;
Vue.component('exportFileBtn', exportFileBtn)

const APP_ENV = import.meta.env.VITE_APP_ENV; //当前环境
console.log(APP_ENV, "APP_ENV 当前环境");

const PROD_ENV = ["pre", "prod"];
// import Vconsole from "vconsole";

if (PROD_ENV.indexOf(import.meta.env.VITE_APP_ENV) === -1) {
  // let vConsole = new Vconsole()
  // Vue.use(vConsole)
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
